/* Sugar Rush Sweet Treats — scoped, accessible on-page category filtering.
   Collection is smaller than Shopify's 30-product page limit. No catalogue mutation,
   no reliance on unavailable Search & Discovery product-type facets.
   Hash-based state is shareable and avoids creating indexable filter URLs. */
(() => {
  const TYPES = new Set(["lollipop","cotton-candy","popcorn"]);
  function init() {
    const nav = document.querySelector(".sr-pm-facets__shortcuts");
    const grid = document.querySelector("#sr-pickmix-products .sr-pm-shop__grid");
    const count = document.querySelector("[data-sr-treat-count]");
    if (!nav || !grid || !count || nav.dataset.srTreatReady === "1") return;
    const buttons = [...nav.querySelectorAll("[data-sr-treat-filter]")];
    const cards = [...grid.querySelectorAll(".sr-pm-shop__card[data-sr-treat-type]")];
    const banners = [...grid.querySelectorAll(".sr-pm-shop__module")];
    if (buttons.length !== 3 || !cards.length) return;
    nav.dataset.srTreatReady = "1";
    const title = {lollipop:"Lollipops", "cotton-candy":"Cotton Candy", popcorn:"Popcorn"};
    let selected = null;
    function render(type) {
      selected = TYPES.has(type) ? type : null;
      let visible = 0;
      cards.forEach(card => {
        const match = !selected || card.dataset.srTreatType === selected;
        card.hidden = !match;
        if (match) visible++;
      });
      banners.forEach(banner => {banner.hidden = !!selected});
      buttons.forEach(button => {
        if (button.dataset.srTreatFilter === selected) button.setAttribute("aria-current","true");
        else button.removeAttribute("aria-current");
      });
      count.textContent = selected ? visible + " " + title[selected] : cards.length + " products";
      grid.dataset.srTreatFilterActive = selected ? "true" : "false";
    }
    function fromHash() {
      const hash = window.location.hash;
      if (!hash.startsWith("#sr-treat-")) return;
      const key = hash.slice("#sr-treat-".length);
      render(key === "all" ? null : key);
    }
    nav.addEventListener("click", event => {
      const link = event.target.closest("[data-sr-treat-filter]");
      if (!link || !nav.contains(link)) return;
      event.preventDefault();
      const type = link.dataset.srTreatFilter;
      const next = selected === type ? null : type;
      const hash = "#sr-treat-" + (next || "all");
      window.history.pushState({srTreatFilter:next},"",window.location.pathname + window.location.search + hash);
      render(next);
    });
    window.addEventListener("popstate", () => {
      const hash = window.location.hash;
      if (hash.startsWith("#sr-treat-")) fromHash();
      else render(null);
    });
    window.addEventListener("hashchange", fromHash);
    const initialHash = window.location.hash;
    if (initialHash.startsWith("#sr-treat-")) fromHash();
    else render(null);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();